import { configureStore } from '@reduxjs/toolkit';

// Reducers
import filtersReducer from './reducers/filtersSlice';
import mapSettingsReducer from './reducers/mapSettingsSlice';
import propertiesReducer from './reducers/propertiesSlice';
import viewportSliceReducer from './reducers/viewportSlice';

const reducers = {
  filters: filtersReducer,
  mapSettings: mapSettingsReducer,
  properties: propertiesReducer,
  viewportSlice: viewportSliceReducer
};

// Middlewares
let middlewares = [];

// Adds redux logger only in developement mode
if (process.env.NODE_ENV === 'development') {
  const { logger } = require('redux-logger');
  middlewares.push(logger);
}

export function setupStore(preloadedState) {
  return configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      immutableCheck: process.env.NODE !== 'test',
      serializableCheck: { warnAfter: 128 },
    }).concat(middlewares),
    reducer: reducers,
    preloadedState
  })
}
